<template>
  <div class="brandPage">
    <!-- banner -->
    <div class="banner">
      <img
        src="https://upload.vwingist.com/melscn/0image/2025/04/5330629802866951358.jpeg"
        alt=""
      />
    </div>

    <div class="group-layout group-layout-1 flex-rowl">
      <div class="media-section">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/02/4798550801738878782.png"
          alt=""
        />
      </div>
      <div class="text-section">
        <h1 class="main-title">起源於阿爾卑斯的自然奇蹟</h1>
        <div class="img-box">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/02/5576840568040327974.png"
            alt=""
          />
        </div>
        <p class="content">
          在瑞士蘇黎世的靜謐山谷中，千年冰川流轉見證了自然的力量與時間的雕刻。<br />
          正是在這片孕育生命奇蹟的土地上，Cellcare
          瑞士實驗室誕生於科學與自然的交會點。<br />
          2017 年，實驗室創立了 VESCOR—<br />
          一個專注於探索肌膚年輕密碼的高端護膚品牌，<br />
          為追求卓越護膚體驗的現代女性，開啟肌膚青春永駐的全新篇章。
        </p>
      </div>
    </div>
    <div class="group-layout group-layout-2 flex-rowl">
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/02/4944469388566994464.png"
          alt=""
        />
      </div>
      <div class="text-section">
        <h1 class="sub-title-1">自然與時間的對話</h1>
        <p class="content">
          使用 VESCOR 護膚品的每一刻，都是與自然與時間的親密對話。<br /><br />
          當細膩的產品輕觸肌膚，猶如阿爾卑斯山的清風拂面。<br />
          瑞士阿爾卑斯山泉純水與天然植物精華深度融合，為肌膚注入源源不斷的生命力。
          <br /><br />
          獨創的「基因抗糖化技術」精準修復歲月痕跡，重塑肌膚彈性與光澤，讓時間的腳步在此停駐。
        </p>
      </div>
    </div>
    <div class="group-layout group-layout-3 flex-rowl">
      <div class="text-section">
        <h1 class="sub-title-1">“美力覺醒・時光無懼”        </h1>
        <h1 class="sub-title-3">是 VESCOR 始終堅持的哲學理念。        </h1>
        <p class="content">
          在繁忙的都市生活中，VESCOR 不僅是一種護膚選擇，更是一種生活方式<br />—— 平衡、從容、優雅。<br />
          在每一個「美力覺醒」的瞬間，<br>破譯「時光無懼」的永恆密鑰。
        </p>
        <!-- <p class="spec">「瑞式奢寵」。</p> -->
      </div>
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5598310805918140272.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
    </div>
    <div class="group-layout group-layout-4 flex-rowl">
      <div class="media-section image-container">
        <img
          src="https://upload.vwingist.com/melscn/0image/2025/04/5557815280427792200.jpeg"
          alt=""
          class="zoomable-image"
        />
      </div>
      <div class="text-section">
        <h1 class="sub-title-1">“瑞士奢寵護膚體驗”</h1>
        <h1 class="sub-title-2">專為內外兼修的現代女性打造        </h1>
        <p class="content">
          在 VESCOR，我們堅信美麗是自然與科學的和諧共生，是內外健康的完美統一。在時光流轉中，也依然能夠堅定地探索自我，綻放獨特光彩。<br />
          選擇 VESCOR，與時間共舞，演繹永恆之美。
        </p>
        <a href="javascript:;" class="more-details flex-rowc"
          @click="handleGo('ProductPage')">了解
          <span class="highlight">“VESCOR奢寵保養體驗計劃”</span> 詳情...</a
        >
      </div>
    </div>

    <div class="new-group-layout flex-rowc">
      <!-- 左边内容 -->
      <div class="new-left-content">
        <h2 class="new-title">
          <span>體驗更多</span><br />
          VESCOR的秘密...
        </h2>
        <p class="new-content">
          阻止膠原蛋白老化，<br />
          重塑肌膚彈性 <br />年輕光澤。
        </p>
        <div class="new-icons flex-rowl">
          <i class="icon-facebook" @click="handleToast"></i>
          <i class="icon-ins" @click="handleToast"></i>
          <i class="icon-cart" @click="handleToast"></i>
          <i class="icon-youtube" @click="handleToast"></i>
          <i class="icon-tiktok" @click="handleToast"></i>
        </div>
      </div>
      <!-- 右边内容 -->
      <div class="new-right-content flex-rowr">
        <!-- 右边内容的左右布局 -->
        <div class="new-right" @click="handleGo('/TechPage')">
          <div class="thumb image-container">
            <img
              src="https://upload.vwingist.com/melscn/0image/2025/02/5434954161480804639.png"
              alt=""
              class="zoomable-image"
            />
          </div>

          <h3 class="new-right-title">瑞士科學研究保障</h3>
          <p class="new-right-text">將科研實力與匠心工藝融為一體。</p>
        </div>
        <div class="new-right" @click="handleGo('/ProductCatalog')">
          <div class="thumb image-container">
            <img
              src="https://upload.vwingist.com/melscn/0image/2025/02/5372742187003798221.png"
              alt=""
              class="zoomable-image"
            />
          </div>

          <h3 class="new-right-title">瑞式奢寵產品系列</h3>
          <p class="new-right-text">讓你的肌膚"體驗阿爾卑斯"</p>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "BrandPage",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleGo(url) {
      this.$router.push(url);
    },

    handleToast() {
      this.$message.warning({
        message: "即将开放",
        center: true,
        duration: 1500,
        offset: 80,
      });
    },
  },
};
</script>
<style lang="less">
.brandPage {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .banner {
    // height: 600px;
    margin-bottom: 110px;
  }
  .group-layout {
    align-items: flex-start;
    &.group-layout-1 {
      padding-left: 280px;
      box-sizing: border-box;
      .media-section {
        width: 500px;
        height: 550px;
        margin-right: 90px;
      }
      .text-section {
        
        .img-box {
          width: 230px;
          height: 179px;
          margin: 48px 0 58px;
        }
      }
    }
    &.group-layout-2 {
      margin-top: -20px;
      padding-left: 448px;
      box-sizing: border-box;
      .media-section {
        width: 360px;
        height: 360px;
        margin-right: 58px;
      }
      .text-section {
        padding-top: 24px;
        .sub-title-1 {
          margin-bottom: 25px;
        }
      }
    }
    &.group-layout-3 {
      padding-left: 330px;
      box-sizing: border-box;
      margin: 123px 0 146px;
      .media-section {
        width: 640px;
        height: 360px;
        margin-left: 80px;
      }
      .text-section {
        .sub-title-3 {
          margin: 10px 0 30px;
        }
        .spec {
          margin-top: 30px;
        }
      }
    }
    &.group-layout-4 {
      box-sizing: border-box;
      padding: 0 380px 0 280px;
      .media-section {
        width: 640px;
        height: 360px;
        margin-right: 86px;
      }
      .text-section {
        .sub-title-2 {
          margin: 46px 0 45px;
          font-family: 'SourceHanSerifCN-Medium', sans-serif;
        }
      }
    }
    .media-section {
      flex-shrink: 0;
    }
    .text-section {
      color: #000000;
      .main-title {
        font-size: 36px;
        font-family: 'SourceHanSerifCN-Medium', sans-serif;
      }
      .sub-title-1 {
        font-size: 28px;
        font-family: 'SourceHanSerifCN-Medium', sans-serif;
      }
      .sub-title-3 {
        font-size: 26px;
        font-family: 'SourceHanSerifCN-Medium', sans-serif;
      }
      .content {
        font-family: 'SourceHanSansCN-Light', sans-serif;
        font-size: 18px;
        line-height: 26px;
      }
      .spec {
        font-size: 36px;
        font-family: 'SourceHanSansCN-Medium', sans-serif;
      }
      .highlight {
        font-size: 22px;
        font-family: 'SourceHanSerifCN-Medium', sans-serif;
      }
      .more-details {
        width: 450px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        color: #000000;
        margin-top: 59px;
        font-family: 'SourceHanSerifCN-Light', sans-serif;
      }
    }
  }
  .new-group-layout {
    margin: 154px auto 176px;
    color: #000000;

    .new-left-content {
      width: 430px;
      flex-shrink: 0;
      margin-right: 35px;
      .new-title {
        font-size: 34px;
        // font-weight: bold;
        font-family: 'SourceHanSerifCN-Medium', sans-serif;
        span {
          font-size: 30px;
        }
      }
      .new-content {
        font-size: 24px;
        margin: 30px 0 55px;
        line-height: 36px;
        font-family: 'SourceHanSansCN-Light', sans-serif;
      }
      .new-icons {
        i {
          display: inline-block;
          cursor: pointer;
          width: 29px;
          height: 29px;
          margin-right: 20px;
        }
        .icon-facebook {
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/5098712633813512321.png);
          background-size: cover;
        }
        .icon-ins {
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4853436759718255243.png);
          background-size: cover;
        }
        .icon-cart {
          width: 34px;
          height: 30px;
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4705043591895584161.png);
          background-size: cover;
        }
        .icon-youtube {
          width: 74px;
          height: 29px;
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4698212167918887025.png);
          background-size: cover;
        }
        .icon-tiktok {
          background-image: url(https://upload.vwingist.com/melscn/0image/2025/02/4973589452167469416.png);
          background-size: cover;
          margin-right: 0;
        }
      }
    }
    .new-right-content {
      .new-right {
        width: 430px;
        flex-shrink: 0;
        &:last-child {
          margin-left: 30px;
        }
        .thumb {
          width: 430px;
          height: 660px;
        }
        .new-right-title {
          font-size: 36px;
          margin: 25px 0 35px;
          font-family: 'SourceHanSerifCN-Medium', sans-serif;
        }
        .new-right-text {
          font-size: 24px;
          font-family: 'SourceHanSansCN-Light', sans-serif;
        }
      }
    }
  }
}
</style>